
import { supabase } from '../integrations/supabase/client';
import { Product } from '../types/product';

export const getProductsFromDatabase = async (): Promise<Product[]> => {
  try {
    const { data, error } = await supabase
      .from('products')
      .select('*');
      
    if (error) {
      console.error('Erro ao buscar produtos:', error);
      throw error;
    }
    
    // Mapear os dados retornados para o formato esperado pela interface Product
    const formattedProducts: Product[] = (data || []).map(item => ({
      id: item.id,
      name: item.name,
      description: item.description || '',
      image: item.image,
      price: item.price || 0, // Garantir que price sempre tenha um valor
      pointsPrice: item.points_price || 0,
      brandId: item.brand_id || '',
      categoryId: item.category_id || '',
      subcategoryId: item.subcategory_id || undefined,
      stock: item.stock || 0,
      additionalImages: item.additional_images
    }));
    
    return formattedProducts;
  } catch (error) {
    console.error('Erro ao processar produtos:', error);
    throw error;
  }
};

export const getProductById = async (id: string): Promise<Product | null> => {
  try {
    const { data, error } = await supabase
      .from('products')
      .select('*')
      .eq('id', id)
      .single();
      
    if (error) {
      console.error(`Erro ao buscar produto com ID ${id}:`, error);
      throw error;
    }
    
    // Se não encontrou o produto, retornar null
    if (!data) return null;
    
    // Mapear o produto para o formato esperado pela interface Product
    const formattedProduct: Product = {
      id: data.id,
      name: data.name,
      description: data.description || '',
      image: data.image,
      price: data.price || 0, // Garantir que price sempre tenha um valor
      pointsPrice: data.points_price || 0,
      brandId: data.brand_id || '',
      categoryId: data.category_id || '',
      subcategoryId: data.subcategory_id || undefined,
      stock: data.stock || 0,
      additionalImages: data.additional_images
    };
    
    return formattedProduct;
  } catch (error) {
    console.error('Erro ao processar produto por ID:', error);
    throw error;
  }
};
